import React,{Component} from 'react';
import {connect} from 'react-redux';
import * as actions from './../../../actions';
import { Link } from 'react-router';
import $ from 'jquery';

const baseAssets = 'https://aquadeals.in/admin/assets/';
export  class Header extends Component{
	constructor(props){
		super(props);
		this.state={
      status: '',
			keyword: '',
		};
	}
  componentWillMount(){
    $('.srh_res').remove();    
  } 
  render(){  
    $(document).on('mouseup',function (e){
      var container = $('.search');
      var container_sub = $('.res');
      if (!container.is(e.target) && container.has(e.target).length === 0)
      {
        container_sub.hide();
      }
      else
      {
        container_sub.hide();
      }
  }); 

  return(
      <div className="mob_deals mob_header">
        <section className="indx_hdr hm_hdr">
            <div className="inx_nav">
                <nav className="navbar navbar-default">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-2 col-sm-3 col-xs-6">
                                <Link className="navbar-brand indx_logo" to={"/"}><img src={baseAssets+'images/web_imgs/abt_logo.png'} title="AquaDeals" alt="AquaDeals" /></Link>
                            </div>
                            <div className="col-md-3 col-sm-4 col-xs-6 pull-right">
                                <ul className="nav navbar-nav navbar-right">
                                  <li style={{textAlign:'right'}}><a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title="Download AquaDeals Mobile App" className="play_img"><img src={baseAssets+'/images/web_imgs/google_play_store_icon.png'} alt="Download" /></a></li>
                                </ul>
                            </div>
                            <div className="col-md-6 col-md-offset-1 col-sm-12 col-xs-12"></div>
                        </div>
                    </div>
                </nav>
            </div>
        </section>
      </div>
    );
}
}


function mapStateToProps(state){
    return {
        search:state.posts.search,
        brands:state.posts.brands,
        products:state.posts.products,
        trendings:state.posts.trendings
    }
}

export default connect(mapStateToProps,actions)(Header);


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/Header.js
 **/